import { useQuery } from "@tanstack/react-query";
import { pathPickOrderDetailQueryApi } from "@/features/pathpick/features/order-history/features/detail/api/query";
import { PathPickOrderDetailResponse } from "@/features/pathpick/features/order-history/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 패스픽 주문 단건 상세 조회 훅 — orderId가 없으면(라우트 파라미터 미확정 등) 조회하지 않는다.
// orderId에는 숫자 id 또는 주문번호(PP-...)를 넣을 수 있다.
const useGetPathPickOrderDetail = (orderId?: number | string) => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickOrderDetail, isPending } = useQuery({
    // 목록 훅과 ["pathpick", "orders", companyId] 프리픽스를 공유해
    // 뮤테이션이 목록/상세를 한 번에 무효화할 수 있게 한다.
    queryKey: ["pathpick", "orders", companyId, orderId],
    // camel 변환을 queryFn에서 수행해 캐시 자체를 camel로 저장한다.
    queryFn: async () => {
      const data = await pathPickOrderDetailQueryApi.getPathPickOrderDetail(
        companyId as number,
        orderId as number | string
      );
      return toCamelKeyObject(data) as PathPickOrderDetailResponse;
    },
    enabled: Boolean(companyId) && Boolean(orderId),
  });

  return { pathPickOrderDetail, isPending };
};

export default useGetPathPickOrderDetail;
